import {Component} from '@angular/core';
import {DateTime, Duration} from 'luxon';
import {TimelineHeaderParams} from './timeline-header.interface';

@Component({
  templateUrl: './timeline-header.component.html',
  styleUrls: ['./timeline-header.component.scss']
})
export class TimelineHeaderComponent {
  public timeList: DateTime[] = [];
  private readonly BOX_WIDTH = 48;

  public agInit(params: TimelineHeaderParams): void {
    this.timeList = this.generateTimeArray(params.startTime, params.totalHours);
    params.api.setColumnWidths([{key: params.column, newWidth: params.totalHours * this.BOX_WIDTH}]);
  }

  private generateTimeArray(startTime: Duration, totalHours: number): DateTime[] {
    const times = [];

    let dateTime = DateTime.now().startOf('day').plus({hours: startTime.hours, minutes: startTime.minutes});

    for (let i = 0; i < totalHours; i++) {
      times.push(dateTime);
      dateTime = dateTime.plus({hours: 1});
    }

    return times;
  }
}
